import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Separator from '../../../components/Separator';
import Tag from '../../../components/Tag';
import './_notificationItem.scss';

const NotificationItem = ({ message, date, type }) => (
  <div className="notification-item">
    <span>{message}</span>
    <div className="type-date">
      <Tag>{type}</Tag>
      <span className="date">{moment(date).format('MMM D - hh:mm A')}</span>
    </div>
    <Separator />
  </div>
);

NotificationItem.propTypes = {
  message: PropTypes.string.isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  type: PropTypes.string.isRequired
};

export default NotificationItem;